export default {
    methods: {
        validateParsleyForm(formId) {
            let form = $(`#${formId}`).parsley();
            form.reset();
            form.validate();

            return form.isValid();
        },
    },
};
